import { render } from "./WorkingPoints.vue?vue&type=template&id=a0d4ae0c&scoped=true"
import script from "./WorkingPoints.vue?vue&type=script&lang=js"
export * from "./WorkingPoints.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=a0d4ae0c&scoped=true&lang=css&external"
import "./WorkingPoints.vue?vue&type=style&index=1&id=a0d4ae0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0d4ae0c"]])

export default __exports__